// 모바일 좌측 패널 동작 — ChatPage 와 LabShell 이 같아야 한다.
//
// 좁은 화면에서는 사이드바 칸이 0폭이라(chat.css @media max-width:760px) 레일 안의
// 접기/펴기 토글에 손이 닿지 않는다. 그래서 셸 밖에 떠 있는 버튼(.side-reopen)으로
// 열고, 바깥을 누르면 닫는다. 이 세 가지가 한 벌로 움직여야 한다.
//
//   1) 처음 진입할 때 모바일이면 접은 상태로 시작    ← 안 하면 오버레이가 화면을 덮는다
//   2) 떠 있는 열기 버튼                              ← 안 하면 다시 열 수단이 없다
//   3) 바깥 클릭·리사이즈 시 접기                     ← 안 하면 오버레이를 닫을 수 없다
//
// LabShell 은 (1)(2)(3)이 전부 없어서, 버핏스코어·유사기업·시장 이슈에서 모바일
// 사용자가 다른 섹션으로 갈 방법이 브라우저 뒤로가기뿐이었다(사용자 제보).
// useRailSettle 과 같은 이유로 훅으로 묶는다 — 셸이 늘어날 때 또 베끼지 않게.
import { useEffect, useRef } from "react";

export const isMobile = () =>
  typeof window !== "undefined" && window.matchMedia("(max-width: 760px)").matches;

/** 첫 렌더의 접힘 초기값. 모바일이면 무조건 접고 시작한다. */
export function initialCollapsed(): boolean {
  try {
    return isMobile() || localStorage.getItem("va_side_collapsed") === "1";
  } catch {
    return false;
  }
}

/**
 * 모바일에서 오버레이 사이드바를 닫는 손잡이들.
 *
 * collapse 는 저장하지 않는 접기여야 한다 — 모바일에서 잠깐 닫은 것이
 * 데스크톱 취향으로 굳으면 안 된다.
 */
export function useMobileSide(collapsed: boolean, collapse: () => void) {
  const ref = useRef(collapsed);
  ref.current = collapsed;

  useEffect(() => {
    const onResize = () => {
      if (isMobile()) collapse();
    };
    const onDocClick = (e: MouseEvent) => {
      if (!isMobile() || ref.current) return;
      const t = e.target as HTMLElement;
      // 사이드바 안과 열기 버튼은 예외 — 누르자마자 닫히면 아무것도 못 고른다
      if (t.closest(".sidebar") || t.closest(".side-reopen")) return;
      collapse();
    };
    window.addEventListener("resize", onResize);
    document.addEventListener("click", onDocClick);
    return () => {
      window.removeEventListener("resize", onResize);
      document.removeEventListener("click", onDocClick);
    };
    // collapse 는 매 렌더 새 함수일 수 있어 의존성에 넣지 않는다 — ref 로 최신 상태를 본다
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
